module.exports = __webpack_public_path__ + "static/img/icon_enlarge.6e0046e1.svg";